module.exports = __webpack_public_path__ + "static/media/banner-logo2.d953dacf.png";